import { gsap, SplitText, ScrollTrigger, ScrollToPlugin } from "@gsap";
/**
 * Layout: Travel navigation
 * Slug: travel_navigation
 */

document.addEventListener('DOMContentLoaded', function () {
	gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

	const layouts = document.querySelectorAll('.flex-layout.travel_navigation-layout');

	layouts.forEach((layout) => {
		const wrapper = layout.querySelector('.navigation-wrapper');

		if (!wrapper) return;

		// Collect the actual layout elements that follow this nav layout, in
		// DOM order, and build one button per sibling that has its own heading.
		const siblingLayouts = [];
		let sibling = layout.nextElementSibling;
		while (sibling) {
			if (sibling.classList.contains('flex-layout')) {
				siblingLayouts.push(sibling);
			}
			sibling = sibling.nextElementSibling;
		}

		const buttons = [];

		siblingLayouts.forEach((target) => {
			const headingText = target.querySelector('.pk-heading-text');		
			
			if (!headingText || !headingText.textContent.trim()) return;

			const button = document.createElement('button');
			button.className = 'scroll-to';
			button.textContent = headingText.textContent.trim();
			wrapper.append(button);
			buttons.push(button);

			button.addEventListener('click', () => {
				const offset = document.querySelector("header").offsetHeight + document.querySelector(".travel_navigation-layout").offsetHeight;
				console.log(offset);
				
				gsap.to(window, {
					duration: 1,
					scrollTo: { y: target, offsetY: offset+40 },
					ease: 'power2.inOut',
				});
			});

			ScrollTrigger.create({
				trigger: target,
				start: 'top center',
				end: 'bottom center',
				onEnter: () => setActive(button),
				onEnterBack: () => setActive(button),
			});
		});

		function setActive(activeButton) {
			buttons.forEach((button) => button.classList.toggle('active', button === activeButton));

			const wrapperRect = wrapper.getBoundingClientRect();
			const buttonRect = activeButton.getBoundingClientRect();
			const scrollLeft = wrapper.scrollLeft
				+ (buttonRect.left - wrapperRect.left)
				- (wrapperRect.width - buttonRect.width) / 2;

			gsap.to(wrapper, {
				scrollLeft,
				duration: 0.4,
				ease: 'power2.out',
			});
		}
	});
});
